import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_LATEST_DOCUMENTS } from 'src/app/shared/utils/archive-v3-redirect.utils';
// Custom packages - Component
import { HistoricalDocsListComponent } from './pages/historical-docs-list.page';
var ɵ0 = {
    permissions: ['canViewLatestDocsInsList'],
    archiveV3Redirect: ARCHIVE_V3_LATEST_DOCUMENTS,
};
var routes = [
    {
        // Opens historical-docs-v3 instead once the 3.0.0 archive is live (FE-A1, ArchiveV3RedirectGuard)
        path: 'list',
        component: HistoricalDocsListComponent,
        canActivate: [ArchiveV3RedirectGuard, RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var HistoricalDocsRoutingModule = /** @class */ (function () {
    function HistoricalDocsRoutingModule() {
    }
    return HistoricalDocsRoutingModule;
}());
export { HistoricalDocsRoutingModule };
export { ɵ0 };
